import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  Domanda,
  GestioneColloquiInizialiScuolaInfanzia,
  StrumentoDiRegistrazioneArchivio,
  VerbaleDiValutazioneEVerifica,
} from '@gpi/lbl/shared/entity';

@Component({
  selector: 'lbl-app-ui-strumento-registrazione-verbale-valutazione-verifica',
  templateUrl: './strumento-registrazione-verbale-valutazione-verifica.component.html',
  styleUrls: ['./strumento-registrazione-verbale-valutazione-verifica.component.scss'],
})
export class StrumentoRegistrazioneVerbaleValutazioneVerificaComponent implements OnInit, OnChanges {
  @Input()
  strumentiDiRegistrazioneArchivio: StrumentoDiRegistrazioneArchivio[] = [];
  @Output()
  updatedStrumentiDiRegistrazioneArchivio: EventEmitter<StrumentoDiRegistrazioneArchivio[]> = new EventEmitter();

  get strumentoDiRegistrazioneArchivio(): StrumentoDiRegistrazioneArchivio {
    return this.strumentiDiRegistrazioneArchivio[0];
  }

  get content(): VerbaleDiValutazioneEVerifica {
    let content = this.strumentoDiRegistrazioneArchivio.content as VerbaleDiValutazioneEVerifica;

    if (!content) {
      content = VerbaleDiValutazioneEVerifica.InitContent();
    }

    return content;
  }

  form: FormGroup;

  get formElencoPresenti(): FormControl {
    return this.form.get('elencoPresenti') as FormControl;
  }
  elencoPresentiSeparatorKeysCodes: number[] = [ENTER, COMMA];

  get formDomande(): FormArray {
    return this.form.get('domande') as FormArray;
  }

  ngOnInit() {
    this.form = this.buildForm();

    this.form.valueChanges.subscribe(() => this.submit(this.form));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.strumentiDiRegistrazioneArchivio && changes.strumentiDiRegistrazioneArchivio.currentValue) {
        this.form = this.updateForm(this.content);
      }
    }
  }

  buildForm(): FormGroup {
    const form = new FormGroup({
      elencoPresenti: new FormControl(this.content.elencoPresenti || []),

      domande: this.buildFormDomande(this.content.domande),
    }, { updateOn: 'blur' });

    return form;
  }

  buildFormDomande(domande: Domanda[]): FormArray {
    const form = new FormArray(domande.map((value) => this.buildFormDomanda(value)));

    return form;
  }

  buildFormDomanda(domanda: Domanda): FormGroup {
    const form = new FormGroup({
      codiceDomanda: new FormControl(domanda.codiceDomanda),
      testoDomanda: new FormControl(domanda.testoDomanda),
      rispostaDomanda: new FormControl(domanda.rispostaDomanda),
    });

    return form;
  }

  updateForm(entity: VerbaleDiValutazioneEVerifica): FormGroup {
    const form = this.buildForm();
    form.patchValue(entity);

    return form;
  }

  addElencoPresenti(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {

      const values: string[] = Object.values(this.formElencoPresenti.value);
      values.push(value.trim());

      this.formElencoPresenti.setValue(values);
    }

    if (input) {
      input.value = '';
    }

    this.form.updateValueAndValidity();
  }

  removeElencoPresenti(index: number): void {
    const values: string[] = Object.values(this.formElencoPresenti.value);
    values.splice(index, 1);
    this.formElencoPresenti.setValue(values);
    this.form.updateValueAndValidity();
  }

  submit(form: FormGroup) {
    if (form.valid) {
      if (form.valid) {
        const strumentiDiRegistrazioneArchivio = [...this.strumentiDiRegistrazioneArchivio];

        const verbaleDiValutazioneEVerifica = new VerbaleDiValutazioneEVerifica(form.value);
        const strumentoDiRegistrazioneArchivio = new StrumentoDiRegistrazioneArchivio({
          ...this.strumentoDiRegistrazioneArchivio,
          content: verbaleDiValutazioneEVerifica,
        });

        strumentiDiRegistrazioneArchivio[0] = strumentoDiRegistrazioneArchivio;
        this.updatedStrumentiDiRegistrazioneArchivio.emit(strumentiDiRegistrazioneArchivio);
      }
    }
  }
}
